import _ from 'underscore';
import Promise from 'bluebird';

function isPending(obj: any) {
  return (obj instanceof Promise) && obj.isPending();
}

/* eslint-disable no-param-reassign */
export function taskQueueMixin(classInstance: Record<string, any>, methodNames: string[]) {
  let asyncTaskQueue: Promise<any> | null = null;

  _.each(methodNames, (methodName) => {
    const originalMethod = classInstance[methodName];

    const wrappedMethod = (...args: any[]) => {
      asyncTaskQueue = isPending(asyncTaskQueue) ?
        asyncTaskQueue.catch(_.noop).then(() => originalMethod.call(classInstance, ...args)) :
        originalMethod.call(classInstance, ...args);

      return asyncTaskQueue;
    };

    classInstance[methodName] = wrappedMethod;
  });
}
